import { faCheckCircle, faCircleExclamation, faClock, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

/**
 * Icono que representa el estado de una solicitud de validación.
 * Props:
 * - pendiente: Valor booleano.
 * - validado: Valor booleano.
 * - sufix: Sufijo de género y número (o, a, os, as).
 * Other props: See FontAwesomeIcon.
 */
export default function EstadoHojaDeFichaje(props) {
    const { generado, firmado, cambiado, className, ...otherProps } = props;
    const bsColor = cambiado ? "warning" : firmado ? "success" : generado ? "muted" : "danger";
    const title = cambiado ? "Los fichajes han sido modificados y es necesario volver a generar el PDF" : firmado ? "Firmado" : generado ? "Pendiente de firma" : "No generado";
    const icon = cambiado ? faCircleExclamation : firmado ? faCheckCircle : generado ? faClock : faTimesCircle;
    return (
        <FontAwesomeIcon
            icon={icon} title={title}
            className={`text-${bsColor} ${className}`}
            {...otherProps}
        />
    );
}
